export default __webpack_public_path__ + "static/media/meter3.495f4990.jpg";